export const getTopicLanguages = <T>(
  topicLanguages: T extends { code: string } ? T[] : never,
  organizationLanguages: { code: string }[],
): T[] =>
  topicLanguages.filter((topicLanguage) =>
    organizationLanguages.some((organizationLanguage) => organizationLanguage.code === topicLanguage.code),
  );
